export const removeItemFromSelectedItems = (variantId, selectedItems) => selectedItems.filter((selectedItem) => selectedItem.variantId !== variantId);
